import {
  ConnectorEnvironments,
  useConnectorEnvironment,
} from 'src/hooks/useConnectorEnvironment';
import { StandardizedConnector } from 'src/products/connector/types/connectorTypes';
import { useConnectorInventoryListDemo } from './useConnectorInventoryListDemo';
import { useConnectorInventoryListProd } from './useConnectorInventoryListProd';

export const useConnectorInventory = (
  canAddConnector: boolean
): {
  error: boolean;
  data: StandardizedConnector[];
} => {
  const environment = useConnectorEnvironment();
  const mvpEnv = environment === ConnectorEnvironments.MVP;

  if (!mvpEnv) {
    return useConnectorInventoryListDemo();
  }

  return useConnectorInventoryListProd(canAddConnector);
};
